import appStoreButton from './../../resources/images/app-store-btn.png';
import playMarketButton from './../../resources/images/play-market-btn.png';
import qrImage from './../../resources/images/scan-qr.png';

import './index.scss';

function Download() {
    return (
        <div className="download-section-wrapper">
            <div className="download-top-panel">
                <h4 className="download-section-title">Download now!</h4>
                <p className="download-section-description">Don't miss a minute and join our community of experts, coaches, and partners today.</p>
                <div className="download-section-buttons">
                    <a href="https://apps.apple.com/app/springbme/id1489137198?ls=1">
                        <img src={appStoreButton} alt=""/>download in app store
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.betconstruct.springbme&fbclid=IwAR1R3vPz3eoqqH6RCdswkCOAMfMI79Sjj3Y3N5ZerWhrgG3-y5aENJYprN0">
                        <img src={playMarketButton} alt=""/>download in play market
                    </a>
                </div>
            </div>
            <div className="download-bottom-panel">
                <img src={qrImage} alt="" />
            </div>
        </div>
    )
}

export default Download;